(function () {
  'use strict';

  var VISIBLE = 'ui-experts-carousel__card--visible';
  var DISABLED = 'ui-experts-carousel__nav-btn--disabled';
  var CONTROLS_HIDDEN = 'ui-experts-carousel__controls--hidden';

  document.querySelectorAll('[data-ui-experts-carousel]').forEach(initCarousel);

  function initCarousel(root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var cards = track.querySelectorAll('.ui-experts-carousel__card');
    if (cards.length === 0) return;

    var initialMax = parseInt(root.getAttribute('data-max-visible'), 10) || 2;
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    var controls = root.querySelector('[data-controls]');

    var currentIndex = 0;
    var maxVisible = computeMaxVisible();
    var lastIndex = -1;
    var lastMaxVisible = -1;
    var resizeTimer = 0;

    function computeMaxVisible() {
      var w = window.innerWidth;
      if (w <= 639) return 1;
      if (w <= 1023) return 2;
      return initialMax;
    }

    function clampIndex() {
      var maxStart = Math.max(0, cards.length - maxVisible);
      if (currentIndex > maxStart) currentIndex = maxStart;
      if (currentIndex < 0) currentIndex = 0;
    }

    function render() {
      clampIndex();
      if (currentIndex === lastIndex && maxVisible === lastMaxVisible) return;
      lastIndex = currentIndex;
      lastMaxVisible = maxVisible;

      cards.forEach(function (card, i) {
        var visible = i >= currentIndex && i < currentIndex + maxVisible;
        card.classList.toggle(VISIBLE, visible);
      });
      if (controls) controls.classList.toggle(CONTROLS_HIDDEN, cards.length <= maxVisible);
      if (prevBtn) prevBtn.classList.toggle(DISABLED, currentIndex === 0);
      if (nextBtn) nextBtn.classList.toggle(DISABLED, currentIndex >= cards.length - maxVisible);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (prevBtn.classList.contains(DISABLED)) return;
        currentIndex -= 1;
        render();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (nextBtn.classList.contains(DISABLED)) return;
        currentIndex += 1;
        render();
      });
    }

    function onResize() {
      if (resizeTimer) cancelAnimationFrame(resizeTimer);
      resizeTimer = requestAnimationFrame(function () {
        maxVisible = computeMaxVisible();
        render();
      });
    }

    window.addEventListener('resize', onResize);

    document.addEventListener('shopify:section:unload', function cleanup(e) {
      if (!e.target || !e.target.contains(root)) return;
      window.removeEventListener('resize', onResize);
      document.removeEventListener('shopify:section:unload', cleanup);
    });

    render();
  }
})();
